import ReactDOM from 'react-dom';
import './Dimensions.scss';


const Dimensions = (props) => {
  const { list } = props;
  const dimensionData = list.dimensionData;

  const adjustParentMarginTop = (arrowEl, parentDiv) => {
    if (!arrowEl || !parentDiv) return;
    const arrowHeight = arrowEl.naturalHeight || arrowEl.height || 0;

    parentDiv.style.marginTop = `-${arrowHeight}px`;

    console.log('Parent margin-top adjusted:', parentDiv.style.marginTop);
  };

  return (
    <>
      {dimensionData.map((hotspot) => {
        const imageSrc = window.isMobIsipadIsPotrait
          ? hotspot?.mobIcon || hotspot?.icon
          : hotspot?.icon;

        const isBottomArrow = hotspot.hsname === 'height_down_popup';

        return ReactDOM.createPortal(
          <div onKeyDown={(event) => {
                  if (event.key !== 'Enter') {
                        return
                     } props.handleMenuClick(list, event)
                  }}
            onClick={(event) => {
              props.handleMenuClick(list, event);
              if (isBottomArrow) {
                const parentDiv = document.getElementById(hotspot.hsname);
                const arrowEl = document.getElementById('arrowImg');
                adjustParentMarginTop(arrowEl, parentDiv);
              }
            }}
            id={hotspot.hsname}
            className={`dimensions popupbox tempHotspot hsParentType_${hotspot.hsParentType} hotspotMenuId_${list.id} ${
              window.selectedConfig['currentSelectedSubmenu'] === hotspot.popupId ? 'active' : ''
            }`}
            data-info={JSON.stringify(hotspot)}
          >
            {!hotspot.icon && !hotspot.icon2 ? (
              <span className="dimensionTextOnly">{hotspot.diamension_text}</span>
            ) : (
              <div className="dimensionWithIcon">
                <img
                  id="arrowImg"
                  src={imageSrc}
                  alt={list.popupHeading}
                  onLoad={(e) => {
                    if (isBottomArrow) {
                      const parentDiv = document.getElementById(hotspot.hsname);
                      adjustParentMarginTop(e.target, parentDiv);
                    }
                  }}
                />
                <span className="dimensionText">{hotspot.diamension_text}</span>
                {hotspot.icon2 && <img src={hotspot.icon2} alt={list.popupHeading} />}
              </div>
            )}
          </div>,
          document.getElementById('dimensionsWrapper')
        );
      })}
    </>
  );
};

export default Dimensions;